import { OnboardingBaseTask } from '@weave/schema-gen-ts/dist/shared/call-intelligence/plg/onboarding.pb';
import { createShallowStore, createStoreWithSubscribe } from '@frontend/store';

export interface OnboardingCallEligibility {
  hasEligibleCall: boolean;
  hasEligibleCallWithContact: boolean;
}

interface OnboardingCallActionStore {
  pendingTask: OnboardingBaseTask | null;
  isEligibilityResolved: boolean;
  eligibility: OnboardingCallEligibility;
  setPendingTask: (task: OnboardingBaseTask) => void;
  clearPendingTask: () => void;
  setEligibility: (eligibility: Partial<OnboardingCallEligibility>) => void;
}

export const useOnboardingCallActionStore = createStoreWithSubscribe<OnboardingCallActionStore>(
  (set) => ({
    pendingTask: null,
    isEligibilityResolved: false,
    eligibility: {
      hasEligibleCall: false,
      hasEligibleCallWithContact: false,
    },
    setPendingTask: (task) => {
      set(
        (state) => {
          state.pendingTask = task;
        },
        false,
        { type: 'SET_PENDING_TASK' }
      );
    },
    clearPendingTask: () => {
      set(
        (state) => {
          state.pendingTask = null;
        },
        false,
        { type: 'CLEAR_PENDING_TASK' }
      );
    },
    setEligibility: (eligibility) => {
      set(
        (state) => {
          state.eligibility = { ...state.eligibility, ...eligibility };
          state.isEligibilityResolved = true;
        },
        false,
        { type: 'SET_ELIGIBILITY' }
      );
    },
  }),
  { name: 'OnboardingCallActionStore', trace: true }
);

export const useOnboardingCallActionShallowStore = createShallowStore(useOnboardingCallActionStore);
